'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = exports.getRelativeValue = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _glamor = require('glamor');

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 Calculation methods for the animaty stuff
*/
var getRelativeValue = exports.getRelativeValue = function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  var rangeValue = max - min;
  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;

  return relValue * 100;
};

/*
 consts used in anims
*/
var duration = '1.5s';

var loading = _glamor.css.keyframes('loading', {
  '0%': { left: '-200px', width: '30%' },
  '50%': { width: '30%' },
  '70%': { width: '70%' },
  '80%': { left: '50%' },
  '95%': { left: '120%' },
  '100%': { left: '100%' }
});

var defaultStyle = exports.defaultStyle = {
  height: 4,
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'inline-block',
  '& .bar': {
    display: 'block',
    position: 'absolute',
    content: '""',
    left: '-200px',
    width: 200,
    height: 4,
    animation: loading + ' ' + duration + ' linear infinite'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      mode = _ref.mode;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (mode === 'determinate') {
    return {
      backgroundColor: backgroundColor || theme.colors.tertiary,
      '& .bar': {
        backgroundColor: color || theme.colors.primary,
        left: 0,
        animation: 'none',
        transition: 'width 250ms linear'
      }
    };
  }

  return (0, _extends3.default)({
    backgroundColor: backgroundColor || theme.colors.tertiary,
    '& .bar': {
      backgroundColor: color || theme.colors.primary
    }
  }, (0, _objectResolvePath2.default)(theme, 'LoadingBar.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/LoadingBar/LoadingBar.style.js
// module id = 554
// module chunks = 0